var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tag-box',{attrs:{"tags":_vm.tags,"font-size":_vm.fontSize},on:{"handleTag":_vm.handleTag}})}
var staticRenderFns = []

export { render, staticRenderFns }